/**
 * Created by Pavel Kozhin on 18/04/16.
 */

define([
        'jQuery',
        'underscore',
        'library/fcse-component/optionsMixin',
        'library/fcse-compatibility/object',
        'clientComponents/map/map',
        'clientComponents/map/detailOverlay'
    ],
    function($, _, OptionsMixin, Object, Map, DetailOverlay) {
        /**
         * MapModal component.
         * @param {jQuery|String} element
         * @param {MultiRequestHandler} requestHandler
         * @param {Object} options
         * @constructor
         */
        var MapModal = function(element, requestHandler, options) {
            // Set default options
            var defaultOptions = {
                openClass: 'is-open',
                closedClass: 'is-closed',
                loadingClass: 'is-loading',
                contentSelector: '[data-fcse-role="map-modal-content"]',
                closeBtnSelector: '[data-fcse-role="map-modal-closebtn"]',
                detailOverlaySelector: '[data-fcse-role="map-modal-detail-overlay"]',
                preflightRoute: 'allt_frontend.map.places_preflight'
            };
            this.addOptions(defaultOptions, options || {});
            this.element = element;
            this._map = null;
            this._requestHandler = requestHandler;
            this._currentId = null;
            this._productSearch = null;
            this._activePlaceId = null;

            this._init();
        };

        MapModal.prototype = $.extend(Object.create(OptionsMixin), Object.create(Map.prototype), {
            /**
             * Opens modal overlay
             * @param {String} id
             * @param {String} productSearch
             * @param {Object} fallbackCenter
             * @param {String} country
             * @param {String} activePlaceId
             */
            open: function(id, productSearch, fallbackCenter, country, activePlaceId) {
                if (!productSearch) {
                    return;
                }
                this.element.get(0).style.display = 'block';

                this._productSearch = productSearch;
                this._activePlaceId = activePlaceId;

                if (this._currentId !== id) {
                    this._currentId = id;
                    this._doPreflightRequest(id, country, fallbackCenter);
                } else if (this._map) {
                    this._map.loadMarkers(this._productSearch, this._activePlaceId);
                }
            },

            /**
             * Closes the modal overlay
             */
            close: function() {
                this.element.get(0).style.display = 'none';

                if (this._map) {
                    this._map.removeMarkers();
                }
                if (this._map && this._map._detailsInfoBox) {
                    this._map._detailsInfoBox.close();
                }
            },

            /**
             * Initializer
             * @private
             */
            _init: function() {
                this._detailOverlay = new DetailOverlay($(this.option('detailOverlaySelector'), this.element));
                this._closeBtnElement = $(this.option('closeBtnSelector'), this.element);

                this._closeBtnElement.click($.proxy(this.close, this));
                this._requestHandler.on('success', $.proxy(this._onPreflightRequestSuccess, this));
            },

            /**
             * Creates and inits Map component
             * @param {Object} bounds
             * @param {Array} locations
             * @param {Object} center
             * @param {Number} zoom
             * @private
             */
            _initMap: function(bounds, locations, center, zoom) {
                if (!this._map) {
                    var self = this;

                    this._map = new Map(this.element, this._requestHandler, {
                        placeDetailsRoute: 'allt_frontend.map.place_details',
                        placesRoute: 'allt_frontend.map.places',
                        mapContainerSelector: '[data-fcse-role="map-modal-content"]',
                        detailInfoBoxFactory: function () {
                            return self._detailOverlay;
                        }
                    });
                    this._map.on('mapCreated', function() {
                        var debouncer = _.debounce($.proxy(self._onBoundsZoomChanged, self), 1500);
                        self._map.getMap().addListener('bounds_changed', debouncer);
                        self._map.getMap().addListener('zoom_changed', debouncer);
                    });
                }
                this._map.create(bounds, locations, center, zoom);
                this._map.removeMarkers();
            },

            /**
             * Request initial map bounds
             * @param {String} destination
             * @param {String} country
             * @param {Object} fallbackCenter
             * @private
             */
            _doPreflightRequest: function(destination, country, fallbackCenter) {
                var options = {method: 'POST'};
                var params = {
                    destination: destination,
                    country: country,
                    fallback_lat: fallbackCenter.latitude,
                    fallback_lng: fallbackCenter.longitude,
                    productSearch: this._productSearch
                };
                if (this._map) {
                    this._map.removeMarkers();
                    this._map.setIsLoading(true);
                }
                this._requestHandler.cancel(this.option('preflightRoute'));
                this._requestHandler.send(this.option('preflightRoute'), params, {}, options);
            },

            /**
             * Updates map viewport
             * @param event
             * @param requestData
             * @private
             */
            _onPreflightRequestSuccess: function(event, requestData) {
                if (event.state !== 'OK') {
                    return;
                }

                if (requestData.route === this.option('preflightRoute')) {
                    this._initMap(event.meta.bounds, event.meta.locations, event.meta.center);
                }
            },

            /**
             * Loads markers on bounds or zoom change
             * @private
             */
            _onBoundsZoomChanged: function() {
                this._map.loadMarkers(this._productSearch, this._activePlaceId);
            }
        });

        var instance;
        var getInstance = function(element, requestHandler, options) {
            return instance || (instance = new MapModal(element, requestHandler, options));
        };

        return {
            getInstance: getInstance
        };
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/map/mapModal.js